import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  // Extracts the pathname from the current location object
  const { pathname } = useLocation();

  // This useEffect hook will run every time the pathname changes
  useEffect(() => {
    // We use `window.scrollTo` with 'instant' behavior.
    // 'smooth' creates an animation that can be interrupted by the old page's
    // components unmounting. 'instant' is a direct command that executes
    // immediately, solving the race condition with GSAP's cleanup.
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Changed from 'smooth'
    });
  }, [pathname]); // The effect depends on the pathname.

  // This component doesn't render any visible content
  return null;
}

export default ScrollToTop;